/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'unit-tree';
const prefix = `${moduleName}.${componentName}`;

export const primarySELabel = `${prefix}.primarySELabel`;

export const ENGLISH = {
    [primarySELabel]: 'Primary SE',
};
